export const itemsBaseApiPath = '/api/common/order-source-integrations';

import {
  fetchItemsGen,
  getItemByIdGen,
  addItemGen,
  editItemGen
} from '../../../utils/apiHelperGenerators.js';

export const fetchItems = fetchItemsGen(itemsBaseApiPath, 'listItems');
export const getItemById = getItemByIdGen(itemsBaseApiPath);
export const addItem = addItemGen(itemsBaseApiPath);
export const editItem = editItemGen(itemsBaseApiPath, 'put');

export default {
  fetchItems,
  getItemById,
  addItem,
  editItem
};
